import React, {createRef, memo, useEffect, useState} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import {Tooltip} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import Grid from "@mui/material/Grid";
import {toast} from "react-toastify";
import MenuItem from "@mui/material/MenuItem";
import Api from "../../utils/api";
import {roleAction, ticketAction, userAction} from "../../actions";
import {connect, useDispatch} from "react-redux";
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import FaceIcon from '@mui/icons-material/Face';
import Avatar from '@mui/material/Avatar';
import InputBase from '@mui/material/InputBase';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import Paper from '@mui/material/Paper';
import SendIcon from '@mui/icons-material/Send';
import './conversation.css'
import PersonIcon from '@mui/icons-material/Person';
import moment from 'moment-jalaali'
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import {Loading} from './../../components'
import {FETCH_TICKET} from "../../types";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Chip from "@mui/material/Chip";
import CategoryIcon from '@mui/icons-material/Category';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const changeStatus = memo((props) => {

    const { ticketReducer, reload, entity, authReducer } = props;

    const dispatch = useDispatch();

    const initStat = {
        category_id: '',
    }

    const [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(false);



    useEffect(() => {
        if (open === false) {
            dispatch({type: FETCH_TICKET, payload: null});
        }
    }, [open]);


    const handlechangeStatus = (category_id) => {

        new Api().put('/tickets/' + entity.id, {status: category_id}, false).then((res) => {
            if (typeof res != "undefined") {
                if (res.status) {
                    toast.success(res.msg);
                    reload();
                    setOpen(false);
                } else {
                    toast.error(res.msg);
                }
            }
        })
    }


    return (
        <>
            <Tooltip title='برای تغییر کلیک کنید.'>
                <Chip size={"small"} clickable={true} variant={"outlined"} onClick={() => setOpen(true)} color={ (entity.status === 'open' || entity.status === 'pending') ? 'secondary' : 'primary'} label={ticketReducer.status[entity.status]} />
            </Tooltip>
            {Boolean(authReducer.user.permissions.ticket.ticket_update.access) &&
            <Dialog open={open} onClose={() => setOpen(false)} TransitionComponent={Transition}>
                <List>
                    {Object.keys(ticketReducer.status).map((status, index) => (
                        <ListItem button  onClick={() => handlechangeStatus(status)}>
                            <ListItemAvatar>
                                <Avatar>
                                    <CategoryIcon />
                                </Avatar>
                            </ListItemAvatar>
                            <ListItemText primary={ticketReducer.status[status]} />
                        </ListItem>
                    ))}
                </List>
            </Dialog>}
        </>
    );

})


const mapStateToProps = state => ({
    ticketReducer: state.ticketReducer,
    authReducer: state.authReducer
});

const mapDispatchToProps = (dispatch) => ({
});



export default connect(mapStateToProps, mapDispatchToProps)(changeStatus)